import React from 'react';
import { Link } from 'react-router-dom';
import { FORGOT_PASSWORD, USER_RECOVERY } from '@constants/routes';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';

const ContainerForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-bottom: 0px;
  ${({ theme }) => theme.newBreakpoint('sm')} {
    margin-bottom: 10px;
  }
`;

const Text = styled.div(
  ({ theme }) => css`
    ${theme.textTypes['Caption-w400']}
    line-height: 1.36;
    color: ${theme.colors.gray700};
    text-align: center;
    transition: all 0.3s ease 0s;
    font-size: 14px;
    a {
      color: ${theme.colors.gbrand500};
      text-decoration: none;
      &:hover {
        color: ${theme.colors.gbrand600};
      }
    }
  `
);

const LoginRecovery = ({ activeUserRecovery }) => {
  const { t } = useTranslation();

  return (
    <ContainerForm>
      <Text>
        {activeUserRecovery ? (
          <>
            {t('login.login.forgotUserAndPassword.0')}
            <Link to={USER_RECOVERY}>
              {t('login.login.forgotUserAndPassword.1', {
                user: t('login.login.forgotUserPlaceholder'),
              })}
            </Link>
            {t('login.login.forgotUserAndPassword.2')}
            <Link to={FORGOT_PASSWORD}>
              {t('login.login.forgotUserAndPassword.3', {
                password: t('login.login.forgotPasswordPlaceholder'),
              })}
            </Link>
          </>
        ) : (
          <>
            {t('login.login.forgotPassword.0')}
            <Link to={FORGOT_PASSWORD}>
              {t('login.login.forgotPassword.1', {
                password: t('login.login.forgotPasswordPlaceholder'),
              })}
            </Link>
          </>
        )}
      </Text>
    </ContainerForm>
  );
};

export default LoginRecovery;
